import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import CreateAuctionListingForm from "../components/CarsBikesBusCustomFiledForm/CreateAuctionListingForm";
import Container from "../components/layout/Container";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const CreateAuctionList = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"Creating Acution Listing"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <CreateAuctionListingForm />
        </div>
      </div>
    </Container>
  );
};

export default CreateAuctionList;
